<template>
  <div class="container content-block" v-if="fetchingNewsItem">
    <div class="row mt-3 mb-3">
      <div class="col text-center">
        <div class="alert alert-info" role="alert">
          Nieuwsbericht ophalen.
        </div>
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Laden...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="newsItem == null">
    <NotFound></NotFound>
  </div>
  <div class="article-detailed" v-else>
    <div class="row">
      <ButtonBack v-on:click="backButtonClicked"></ButtonBack>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="article">
          <div class="info">
            <p class="dateline">{{ formatDayDateMonthYear(newsItem.publicationStatus.lastPublicationDate) }}</p>
            <p class="title">{{ newsItem.title }}</p>
          </div>
          <div class="image">
            <img class="img-fluid" :src="newsItem.bannerImage?.url" :alt="'Nieuwsbericht afbeelding ' + newsItem.title">
          </div>
          <div class="row video-container mt-5" v-if="newsItem.video">
            <div class="col">
              <div class="video-wrapper">
                <div class="embed-responsive embed-responsive-16by9 video-preview mx-auto">
                  <iframe class="embed-responsive-item" :src="convertYoutubeUrlToEmbedUrl(newsItem.video)"
                          title="YouTube video player"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>
          <div class="article-body">
            <p>{{ newsItem.content }}</p>
          </div>
          <div class="related-activity" v-if="newsItem.relatedQuests && newsItem.relatedQuests.length">
            <p class="title">Gerelateerde activiteit</p>
            <QuestSmall class="related-activity-button" v-for="quest in newsItem.relatedQuests" :key="quest.id"
                        :quest="quest" :interactable="true"></QuestSmall>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="other-articles-card">
          <div class="header">
            <h2 class="title">Alle berichten</h2>
          </div>
          <ArticleList :news-items="newsItems" :total-news-items="info.totalElements"
                       :news-items-per-page="itemsPerPage"></ArticleList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleList from "@/components/News/ArticleList";
import ButtonBack from "@/components/UI/ButtonBack";
import { NewsApi } from "sandpiper_api";
import DateFormatter from "@/mixins/DateFormatter";
import QuestSmall from "@/components/Quests/QuestSmall";
import YoutubeVideoEmbedder from "@/mixins/YoutubeVideoEmbedder";
import NotFound from "@/components/Common/NotFound";

export default {
  name: "ArticleDetailed",
  components: {QuestSmall, ArticleList, ButtonBack, NotFound},
  mixins: [DateFormatter, YoutubeVideoEmbedder],
  props: {},
  inject: ["doApiRequest"],
  data() {
    return {
      fetchingNewsItem: false,
      newsItem: null,

      fetchingNewsItems: false,
      newsItems: [],
      info: {},
      page: 1,
      itemsPerPage: 6
    }
  },
  methods: {
    backButtonClicked()
    {
      this.$router.push({ name: "news-overview" });
    },
    fetchPathParams()
    {
      this.newsItemId = this.$route.params.id;
    },
    async fetchNewsItem()
    {
      try
      {
        this.fetchingNewsItem = true;
        this.newsItem = await this.doApiRequest(() => new NewsApi().getNewsItem(this.newsItemId));
      }
      catch (e)
      {
        this.newsItem = null;
        // TODO - handle exception, return to news overview?
        // await this.$router.push({name: 'news-overview'});
      }
      finally
      {
        this.fetchingNewsItem = false;
      }
    },
    async fetchNewsItems()
    {
      try
      {
        this.fetchingNewsItems = true;

        this.newsItems = [];

        // Fetch the new quests
        const response = await this.doApiRequest(() => new NewsApi().getPublishedNewsItems({
          count: this.itemsPerPage,
          page: this.page - 1
        }));

        this.newsItems = response.newsItems;
        this.info = {
          currentPage: response.currentPage,
          numberOfElements: response.numberOfElements,
          totalPages: response.totalPages,
          totalElements: response.totalElements
        };
      }
      catch (e)
      {
        // TODO - handle error
      }
      finally
      {
        this.fetchingNewsItems = false;
      }
    }
  },
  created()
  {
    this.fetchPathParams();
    this.fetchNewsItem();
    this.fetchNewsItems();
  }
}
</script>

<style lang="scss" scoped>
.article-detailed
{
  max-width: 1259px;
  margin: 0 auto;
  margin-bottom: 4rem;
}

.article, .other-articles-card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  margin-top: 15px;

  .title
  {
    font-weight: bold;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.other-articles-card, .related-activity
{
  padding: 25px;

}

.article
{
  display: flex;
  flex-direction: column;

  .image
  {
    max-height: 410px;
    display: flex;
    margin-bottom: 1rem;

    .img-fluid {
      object-fit: cover;
    }
  }

  .info
  {
    padding: 18px 25px;
    flex: 2 2;
    min-height: 112px;

    .dateline
    {
      font-size: $body-text-size;
      font-style: italic;
      color: $font-grey;
      margin-bottom: 0px;

    }

    .title
    {
      font-size: $title-size;
      font-weight: bold;
      margin-bottom: 0px;

    }
  }

  .article-body
  {
    padding: 25px;

    p {
      white-space: pre-line;
    }
  }

  .video-wrapper
  {
    padding: 0 90px;
  }

  .related-activity-button
  {
    @media screen and (min-width: $medium)
    {
      max-width: 402px;
    }
  }
}

</style>